"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSwatches = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common");
/**
 * 토큰마다 달라지는 선언 하나씩을 공통 박스에 칠해 번호와 함께 늘어놓는다.
 * 번호는 스와치를 가리키는 순번이며, 아래 토큰 목록과 같은 순서로 놓아야 짝이 맞는다.
 */
let TokenSwatches = class TokenSwatches extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        /** 칠할 CSS 선언 문자열. 원소마다 스와치 하나가 된다. */
        this.swatches = [];
        this.gap = '4';
    }
    render() {
        return (0, lit_1.html) `
      ${this.swatches.map((swatch, index) => this.renderSwatch(swatch, index))}
    `;
    }
    renderSwatch(swatch, index) {
        return (0, lit_1.html) `
      <div class="column">
        <div class="swatch" style=${swatch}></div>
        <mm-list-marker variant="number" value=${index + 1}></mm-list-marker>
      </div>
    `;
    }
};
TokenSwatches.styles = (0, lit_1.css) `
    :host {
      --token-swatches-gap: var(--space-4);

      display: flex;
      align-items: flex-end;
      gap: var(--token-swatches-gap);
      /* hover lift 스와치가 위로 뜬 만큼 mm-scroll의 overflow가 잘라내지 않도록 남기는 여유 */
      padding-top: var(--space-1);
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('gap', (0, shared_styles_1.spaceTokens)('--token-swatches-gap')))}

    .swatch {
      flex-shrink: 0;
      width: var(--size-48);
      height: var(--size-48);
      border-radius: var(--radius);
      background: var(--background-color);
    }

    .column {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--space-2);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], TokenSwatches.prototype, "swatches", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], TokenSwatches.prototype, "gap", void 0);
TokenSwatches = __decorate([
    (0, decorators_js_1.customElement)('mm-token-swatches')
], TokenSwatches);
exports.TokenSwatches = TokenSwatches;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4tc3dhdGNoZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b2tlbi1zd2F0Y2hlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0Q7QUFDdEQscURBQTJEO0FBRTNELCtEQUFxRTtBQUNyRSxtQ0FBNkM7QUFDN0MsK0JBQTRCO0FBRTVCOzs7R0FHRztBQUVJLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxnQkFBVTtJQUF0Qzs7UUE2Qkwsc0NBQXNDO1FBQ04sYUFBUSxHQUFhLEVBQUUsQ0FBQTtRQUNaLFFBQUcsR0FBVSxHQUFHLENBQUE7SUFnQjdELENBQUM7SUFkQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtRQUNQLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7S0FDekUsQ0FBQTtJQUNILENBQUM7SUFFTyxZQUFZLENBQUMsTUFBYyxFQUFFLEtBQWE7UUFDaEQsT0FBTyxJQUFBLFVBQUksRUFBQTs7b0NBRXFCLE1BQU07aURBQ08sS0FBSyxHQUFHLENBQUM7O0tBRXJELENBQUE7SUFDSCxDQUFDOztBQTdDTSxvQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7OztNQVdmLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsS0FBSyxFQUFFLElBQUEsMkJBQVcsRUFBQyxzQkFBc0IsQ0FBQyxDQUFDLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7R0FnQjdFLENBQUE7QUFFK0I7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDOytDQUF3QjtBQUNaO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzBDQUFpQjtBQS9CaEQsYUFBYTtJQUR6QixJQUFBLDZCQUFhLEVBQUMsbUJBQW1CLENBQUM7R0FDdEIsYUFBYSxDQStDekI7QUEvQ1ksc0NBQWEifQ==